//
//
//
//
import error401 from '@/assets/images/error-page/error-401.svg';
import errorContent from './error-content.vue';
export default {
  name: 'error_401',
  components: {
    errorContent: errorContent
  },
  data: function data() {
    return {
      src: error401
    };
  }
};